// extracted by mini-css-extract-plugin
export default {"txtSearch":"PendingMessages_txtSearch__altHi"};